export const MIN_PLOT_AREA_WIDTH = 450
export const PLOT_AREA_HEIGHT = 160
export const PLOT_AREA_PADDING_TOP = 37
export const PLOT_AREA_PADDING_RIGHT = 22
export const PLOT_AREA_PADDING_LEFT = 0
export const X_AXIS_HEIGHT = 40
export const Y_AXIS_WIDTH = 80

export const PROCESSING_TIME_TREND_TIMEFRAME_OPTIONS = [
  {
    value: '6',
    label: '6 months',
  },
  {
    value: '12',
    label: '1 year',
  },
  {
    value: '24',
    label: '2 years',
  },
]

export const LAST_PROCESSING_TIME_TREND_TIMEFRAME_VALUE =
  PROCESSING_TIME_TREND_TIMEFRAME_OPTIONS[PROCESSING_TIME_TREND_TIMEFRAME_OPTIONS.length - 1].value
